import React from 'react'
import { StyleSheet } from 'react-native'
import { MaterialCommunityIcons } from '@expo/vector-icons'
import { CreditCardModel } from '@/domain/models'
import { useThemeClient } from '@/presentation/hooks'
import { Box, HStack, TextInput, VStack } from '@/presentation/components'
import { numberMask, validityCardMask } from '@/presentation/utils'

type AddNewCreditCardProps = {
  creditCard: CreditCardModel
  onChange: (field: string, value: string) => void
  isLoading: boolean
  isEditable: boolean
}

export const AddNewCreditCard: React.FC<AddNewCreditCardProps> = ({
  creditCard,
  onChange,
  isEditable,
  isLoading
}) => {
  const { getThemeClient } = useThemeClient()

  const themeClient = getThemeClient()

  return (
    <Box style={styles.formArea}>
      <VStack spacing={12}>
        <TextInput
          color={themeClient.mainColor}
          editable={!isLoading && isEditable}
          value={creditCard?.nome}
          label="Nome no cartão"
          onChangeText={(text) => onChange('nome', text)}
        />
        <TextInput
          color={themeClient.mainColor}
          editable={!isLoading && isEditable}
          value={creditCard?.numero}
          keyboardType='numeric'
          label="Número do cartão"
          maxLength={16}
          onChangeText={(text) => onChange('numero', text)}
        />
        <HStack spacing={16}>
          <TextInput
            color={themeClient.mainColor}
            maxLength={5}
            editable={!isLoading && isEditable}
            inputStyle={{ width: '100%' }}
            style={{ flex: 2 }}
            value={creditCard?.expiracao}
            label="Vencimento"
            keyboardType='numeric'
            trailing={(props) => <MaterialCommunityIcons name="calendar-range" {...props} />}
            onChangeText={(text) => onChange('expiracao', validityCardMask(text))}
          />
          <TextInput
            color={themeClient.mainColor}
            editable={!isLoading && isEditable}
            inputStyle={{ width: '100%' }}
            style={{ flex: 1 }}
            value={creditCard?.ccv}
            maxLength={4}
            keyboardType='numeric'
            label="CVC"
            onChangeText={(text) => onChange('ccv', numberMask(text))}
          />
        </HStack>
      </VStack>
    </Box>
  )
}

const styles = StyleSheet.create({
  formArea: {
    width: '100%',
    maxWidth: 428,
    padding: 16
  }
})
